import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'environments/environment';

import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ClienteContatoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }
	public create(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}cliente-contato/`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	
	public put(data: any, id: number, pIdCliente: number, isDefault: boolean): Observable<any> {
		return this.http
			.put<any>(`${this.url}cliente-contato/update/${id}`, {
				setor: data.value.setor,
				tipo: data.value.tipo,
				nome: data.value.nome,
				telefone: data.value.telefone,
				whatsapp: data.value.whatsapp,
				email: data.value.email,
				isDefault: isDefault,
				id_cliente: pIdCliente
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public findOne(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}cliente-contato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public delete(id: number): Observable<any> {
		return this.http.delete<any>(`${this.url}cliente-contato/delete/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public get(): Observable<Array<any>> {
		return this.http.get<Array<any>>(`${this.url}cliente-contato`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getIdCliente(id_cliente: number): Observable<any> {
		return this.http.get<any>(`${this.url}cliente-contato/getIdCliente/${id_cliente}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getEdit(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}cliente-contato/getEdit/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getDefault(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}cliente-contato/getDefault/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}
}
